export class TicToc {
    constructor() {
        this.ticAt = Date.now();
    }
    toc() {
        return Date.now() - this.ticAt;
    }
}
//# sourceMappingURL=tic-toc.js.map